import type {ITheme} from "@xterm/xterm";
import type {ISearchDecorationOptions} from "@xterm/addon-search";

export type ThemeSet = {
    defaultTheme: ITheme
    invertTheme: ITheme
    searchDecorationOptions: ISearchDecorationOptions
}

const themeSetDict: Record<string, ThemeSet> = {
    "ubuntu": {
        defaultTheme: {
            background: "#300a24",
            black: "#2e3436",
            blue: "#3465a4",
            brightBlack: "#555753",
            brightBlue: "#729fcf",
            brightCyan: "#34e2e2",
            brightGreen: "#8ae234",
            brightMagenta: "#ad7fa8",
            brightRed: "#ef2929",
            brightWhite: "#eeeeec",
            brightYellow: "#fce94f",

            cursor: "#ffffff",
            cursorAccent: "#000000",
            cyan: "#06989a",

            extendedAnsi: [
                "#2e3436", "#cc0000", "#4e9a06", "#c4a000",
                "#3465a4", "#75507b", "#06989a", "#d3d7cf",
                "#555753", "#ef2929", "#8ae234", "#fce94f",
                "#729fcf", "#ad7fa8", "#34e2e2", "#eeeeec"
            ],

            foreground: "#ffffff",
            green: "#4e9a06",
            magenta: "#75507b",
            red: "#cc0000",

            selectionBackground: "rgba(255,255,255,0.3)",
            selectionForeground: "#ffffff",
            selectionInactiveBackground: "rgba(255,255,255,0.1)",

            white: "#d3d7cf",
            yellow: "#c4a000",

        },
        invertTheme: {
            background: "#ffffff",
            black: "#d3d7cf",
            blue: "#729fcf",
            brightBlack: "#eeeeec",
            brightBlue: "#3465a4",
            brightCyan: "#06989a",
            brightGreen: "#4e9a06",
            brightMagenta: "#75507b",
            brightRed: "#cc0000",
            brightWhite: "#2e3436",
            brightYellow: "#c4a000",

            cursor: "#000000",
            cursorAccent: "#ffffff",
            cyan: "#34e2e2",

            extendedAnsi: [
                "#d3d7cf", "#ef2929", "#8ae234", "#fce94f",
                "#729fcf", "#ad7fa8", "#34e2e2", "#2e3436",
                "#eeeeec", "#cc0000", "#4e9a06", "#c4a000",
                "#3465a4", "#75507b", "#06989a", "#555753"
            ],

            foreground: "#000000",
            green: "#8ae234",
            magenta: "#ad7fa8",
            red: "#ef2929",

            selectionBackground: "rgba(0,0,0,0.3)",
            selectionForeground: "#000000",
            selectionInactiveBackground: "rgba(0,0,0,0.1)",

            white: "#2e3436",
            yellow: "#fce94f",
        },
        searchDecorationOptions: {
            matchBackground: 'rgba(50,50,50)',
            activeMatchBackground: 'rgba(100,100,100)',
            matchOverviewRuler: 'rgba(50,0,0)',
            activeMatchColorOverviewRuler: 'rgba(100,0,0)'
//     ^(https?):\/\/([^:\/\s]+)(:([^\/]*))?((\/[^\s/\/]+)*)?\/?([^#\s\?]*)(\?([^#\s]*))?(#(\w*))?
        }
    },

    "rocky": {
        defaultTheme: {},
        invertTheme: {},
        searchDecorationOptions: {
            matchBackground: 'rgba(50,50,50)',
            activeMatchBackground: 'rgba(100,100,100)',
            matchOverviewRuler: 'rgba(50,0,0)',
            activeMatchColorOverviewRuler: 'rgba(100,0,0)'
        }
    },

    "blank": {
        defaultTheme: {
            background: "#ffffff"
        },
        invertTheme: {
            background: "#ffffff"
        },
        searchDecorationOptions: {
            matchBackground: 'rgba(50,50,50)',
            activeMatchBackground: 'rgba(100,100,100)',
            matchOverviewRuler: 'rgba(50,0,0)',
            activeMatchColorOverviewRuler: 'rgba(100,0,0)'
        }
    }
}


function getThemeSet(os: string, defaultName: string = "blank"): ThemeSet {
    for (const [key, value] of Object.entries(themeSetDict)) {
        if (os.toLowerCase().startsWith(key)) return value;
    }
    return themeSetDict[defaultName];
}

export default getThemeSet;